module.exports = __webpack_public_path__ + "static/img/repast_2.4433f328.jpg";